export default __webpack_public_path__ + "static/media/Ritviz_-_Ved.1ff737bd.mp3";